export default {
    validations: {
        endYear: (value) => /^\d{4}$/.test(value),
        firstRecord: (value) => value >= -1 && value < 999,
        mileage: (value) => /^\d+$/.test(value),
        maxPrice: (value) => /^\d+$/.test(value),
        minPrice: (value) => /^\d+$/.test(value),
        listingId: {
            required: true,
            test: (value) => /^\d+(,\d+)*$/.test(value),
        },
        numRecords: (value) => value >= -1 && value <= 100,
        searchRadius: (value) => value >= 0 && value <= 500,
        startYear: (value) => /^\d{4}$/.test(value),
    },
};
